import dayjs from "dayjs";

export const labelStyles = {
  color: "#828282",
  fontSize: "16px",
  position: "relative",
  top: "7px",
};

export const isValidMediaId = (id) =>
  typeof id === "string" && /^[0-9a-fA-F]{24}$/.test(id);

export const getChallengeBackgroundUrl = (challenge) => {
  if (!challenge) return null;
  const bg = challenge.backgroundImage;
  if (typeof bg === "string" && bg) return bg;
  if (bg?.url) return bg.url;
  return null;
};

// Keep in sync with MAX_CHALLENGE_STICKERS in the backend (category.validations.js)
export const MAX_STICKERS = 10;

// Mirrors the backend rule in category.controller.js
export const STICKER_EXCLUDED_CATEGORY_NAMES = ["Karaoke", "Dance", "Art"];

export const isStickerEligibleCategory = (category) =>
  Boolean(category) &&
  category.type !== "live" &&
  !STICKER_EXCLUDED_CATEGORY_NAMES.includes(category.name);

// Karaoke and dance pagents group by song, and live categories are battles.
// Those challenges have no voting-feed group size of their own.
export const isFeedGroupSizeEligibleCategory = (category) => {
  if (!category || category.type === "live") return false;
  const shortName = (category.categoryShortName || category.name || "")
    .toString()
    .trim()
    .toLowerCase();
  return shortName !== "karaoke" && shortName !== "dance";
};

// Accepts { mediaId, url } objects and legacy bare-URL strings
export const normalizeStickers = (challenge) =>
  (challenge?.stickers || [])
    .map((sticker) =>
      typeof sticker === "string"
        ? { mediaId: null, url: sticker }
        : {
            mediaId: sticker?.mediaId || sticker?._id || null,
            url: sticker?.url || "",
          }
    )
    .filter((sticker) => sticker.url);

export const getChallengeStatus = (startDate, endDate) => {
  if (!startDate || !endDate) {
    return { status: "Date TBD", color: "default", bgColor: "#e2e3e5" };
  }

  const now = dayjs();
  const start = dayjs(startDate);
  const end = dayjs(endDate);

  if (now.isBefore(start)) {
    return { status: "Scheduled", color: "warning", bgColor: "#fff3cd" };
  } else if (now.isAfter(end)) {
    return { status: "Ended", color: "error", bgColor: "#f8d7da" };
  } else {
    return { status: "In Progress", color: "success", bgColor: "#d1edff" };
  }
};
